import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from '@app/shared';
import {accountRoute} from '@entities/account/account.route';
import {PersonalSettingComponent} from '@entities/account/personal-setting/personal-setting.component';

const ENTITY_STATES = [...accountRoute];

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule.forChild(ENTITY_STATES)],
  declarations: [PersonalSettingComponent],
})
export class AccountModule {}
